import {
  List,
  Datagrid,
  TextField,
  FunctionField,
  Resource,
} from "react-admin";

// Read-only list of the catalog aliases (translations) valid for the account the
// admin currently has selected: the account's own aliases + the global (accountId
// NULL) ones shared by Bcome. Account scope comes from tokenOps.account in the
// dataProvider, which appends /:accountId to the endpoint.
// CatalogAlias is not account-segregated at the DB level, so the backend filters
// (accountId = :id OR accountId IS NULL) explicitly.
const AccountTranslationsList = (props) => (
  <List {...props} perPage={50} bulkActionButtons={false}>
    <div style={{ marginTop: "15px" }}>
      <Datagrid>
        <TextField source="catalogTable" label="Catalog table" />
        <TextField source="alias" label="Alias" />
        <TextField source="targetId" label="Target id" />
        <TextField source="language" label="Language" />
        <TextField source="confidence" label="Confidence" />
        <TextField source="source" label="Source" />
        <FunctionField
          label="Scope"
          render={(record) => (record.accountId ? "Account" : "Global")}
        />
      </Datagrid>
    </div>
  </List>
);

const accountTranslationsResource = () => (
  <Resource
    name="accountTranslations"
    options={{ label: "Translations", menuGroup: "Accounts" }}
    list={AccountTranslationsList}
  />
);

export default accountTranslationsResource;
